import { mediator } from '../../../mediator/mediatorInstance.js';

import { MainMapMarkerManager } from './MainMapMarkerManager.js';

export class ArchiveMarkerManager extends MainMapMarkerManager {
    markerFactory;

    constructor(mapAdapter, markerFactory) {
        super(mapAdapter);
        this.markerFactory = markerFactory;
    }

    addMarkers(markerDataArray) {
        this.clearMarkersByType('archive');

        for(const data of markerDataArray) {
            const marker = this.markerFactory.createArchiveMarker(
                this.mapAdapter.getMapInstance(),
                data.name,
                data.lat,
                data.lng
            );

            marker.setActiveState = function(isActive) {
                if(!marker.content) { return; }

                const contentDiv = marker.content;

                if(isActive) {
                    contentDiv.classList.add('hovered');
                    contentDiv.style.backgroundPosition = `-${parseInt(contentDiv.dataset.x) + 27}px -${parseInt(contentDiv.dataset.y)}px`;
                } else {
                    contentDiv.classList.remove('hovered');
                    contentDiv.style.backgroundPosition = `-${parseInt(contentDiv.dataset.x)}px -${parseInt(contentDiv.dataset.y)}px`;
                }
            }

            this._registerMarkerEvents(marker, data);
            this.addMarker(marker, data.id, 'archive', null, null);
        }
    }

    _registerMarkerEvents(marker, data) {
        marker.addListener('gmp-click', () => {
           mediator.publish('marker:archive:click', { marker, data });
        });
        if(marker.content) {
            marker.content.addEventListener('mouseover', () => {
               mediator.publish('marker:archive:mouseover', { marker, data });
            });
            marker.content.addEventListener('mouseout', () => {
                mediator.publish('marker:archive:mouseout', { marker, data });
            })
        }
    }

    highlightMarkerById(id, active = true) {
        const markers = this.getMarkerById(id);
        if(!markers) { return; }
        for(const marker of markers) {
            if(marker.marker && typeof marker.marker.setActiveState === 'function') {
                marker.marker.setActiveState(active);
            } else if( import.meta.env.DEV ) {
                console.warn('Missing setActiveState handler for marker', marker.marker);
            }
        }
    }
}